@if (pageReady) {
  <main class="gs-page">
    <div class="renewal-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      @if (isSSMProcess) {
        <app-ssm-stepper [process]="process" [step]="step"></app-ssm-stepper>
      }
      <div class="gs-content-container">
        <form class="" [formGroup]="rateForm">
          <div class="top-content-container">
            <div class="rate-content">
              <h2 class="content-header">{{ pageLabels.contentHeader }}</h2>
              <p>{{ pageLabels.contentSubheader }}</p>
              @if (showRateNotSelectedError) {
                <p class="gs-error no-rate-selected-error">{{ pageLabels.rateNotSelectedErrorText }}</p>
              }
              <mat-accordion multi class="all-rates-container">
                @for (productCode of rateInfo.ProductCodes; track productCode; let first = $first) {
                  @if (productCode === "OPP") {
                    <mat-expansion-panel [class]="productCode" [expanded]="first" hideToggle #panel="matExpansionPanel">
                      <mat-expansion-panel-header>
                        <div class="product-header">
                          <div class="product-type-header-container">
                            <h3 class="product-type-header" [innerHTML]="oppRateHeader"></h3>
                            @if (accountDetail.IsOnePricePlan) {
                              <p class="header-badge">{{ pageLabels.currentPlanBadge }}</p>
                            } @else {
                              <p class="header-badge">{{ pageLabels.customerPrefBadge }}</p>
                            }
                          </div>
                          <p class="product-type-desc">
                            {{ pageLabels.oppPlanDescription }}
                            <button
                              class="gs-button-link"
                              (click)="openCalculatedTooltip($event)"
                              (keydown.enter)="openCalculatedTooltip($event)"
                            >
                              {{ pageLabels.calculatedTooltipBtnText }}
                            </button>
                          </p>
                        </div>
                        <div class="toggle-icon">
                          @if (!panel.expanded) {
                            <i class="fa-solid fa-lg fa-plus"></i>
                          }
                          @if (panel.expanded) {
                            <i class="fa-solid fa-lg fa-minus"></i>
                          }
                        </div>
                      </mat-expansion-panel-header>
                      <div class="rate-desc-container">
                        <div class="rate-tile-container">
                          @for (rate of oppRates; let i = $index; track rate) {
                            <button
                              class="rate-tile-background {{ productCode }}-tile-{{ i }}"
                              (click)="selectRate(productCode, i, rate)"
                            >
                              <div class="rate-tile">
                                <p class="rate-length">{{ rate.ContractLength }} {{ pageLabels.rateTermMonthsText }}</p>
                                <p class="rate-price" [innerHTML]="rate.PricePerTherm | perTherm: true"></p>
                                <p class="rate-therm-text">{{ pageLabels.pricePerMonthText }}</p>
                              </div>
                            </button>
                          }
                        </div>
                        <div class="rate-desc">
                          <p>{{ pageLabels.planIncludesText }}</p>
                          <ul>
                            @for (bullet of pageLabels.oppIncludesList; track $index) {
                              <li>{{ bullet.bullet }}</li>
                            }
                          </ul>
                          <p>{{ pageLabels.oppDisclaimer }}</p>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  } @else if (productCode === "FIXED") {
                    <mat-expansion-panel
                      [class]="productCode"
                      [expanded]="first"
                      hideToggle
                      #panel2="matExpansionPanel"
                    >
                      <mat-expansion-panel-header>
                        <div class="product-header">
                          <div class="product-type-header-container">
                            <h3 class="product-type-header" [innerHTML]="fixedRateHeader"></h3>
                          </div>
                          <p class="product-type-desc" [innerHTML]="pageLabels.fixedPlanDescription"></p>
                          <button
                            id="fixedThermTT"
                            (click)="$event.stopPropagation()"
                            class="gs-tooltip-btn"
                            [matTooltip]="pageLabels.thermTooltip"
                            [attr.aria-label]="pageLabels.thermTooltipAriaLabel"
                          >
                            <i class="fa-solid fa-circle-question gs-tooltip"></i>
                          </button>
                        </div>
                        <div class="toggle-icon">
                          @if (!panel2.expanded) {
                            <i class="fa-solid fa-lg fa-plus"></i>
                          }
                          @if (panel2.expanded) {
                            <i class="fa-solid fa-lg fa-minus"></i>
                          }
                        </div>
                      </mat-expansion-panel-header>
                      <div class="rate-desc-container">
                        <div class="rate-tile-container">
                          @for (rate of fixedRates; let i = $index; track rate) {
                            <button
                              class="rate-tile-background {{ productCode }}-tile-{{ i }}"
                              (click)="selectRate(productCode, i, rate)"
                            >
                              <div class="rate-tile">
                                <p class="rate-length">{{ rate.ContractLength }} {{ pageLabels.rateTermMonthsText }}</p>
                                <p class="rate-price" [innerHTML]="rate.PricePerTherm | perTherm: true"></p>
                                <p class="rate-therm-text">{{ pageLabels.pricePerThermText }}</p>
                              </div>
                            </button>
                          }
                        </div>
                        <div class="rate-desc">
                          <p>{{ pageLabels.planIncludesText }}</p>
                          <ul>
                            @for (bullet of pageLabels.fixedIncludesList; track $index) {
                              <li>{{ bullet.bullet }}</li>
                            }
                          </ul>
                          <p>{{ pageLabels.fixedDisclaimer }}</p>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  } @else if (productCode === "VAR") {
                    <mat-expansion-panel
                      [class]="productCode"
                      [expanded]="first"
                      hideToggle
                      #panel3="matExpansionPanel"
                    >
                      <mat-expansion-panel-header>
                        <div class="product-header">
                          <div class="product-type-header-container">
                            <h3 class="product-type-header" [innerHTML]="variableRateHeader"></h3>
                          </div>
                          <p class="product-type-desc" [innerHTML]="pageLabels.variablePlanDescription"></p>
                        </div>
                        <div class="toggle-icon">
                          @if (!panel3.expanded) {
                            <i class="fa-solid fa-lg fa-plus"></i>
                          }
                          @if (panel3.expanded) {
                            <i class="fa-solid fa-lg fa-minus"></i>
                          }
                        </div>
                      </mat-expansion-panel-header>
                      <div class="rate-desc-container">
                        <div class="rate-tile-container">
                          @for (rate of variableRates; let i = $index; track rate) {
                            <button
                              class="rate-tile-background {{ productCode }}-tile-{{ i }}"
                              (click)="selectRate(productCode, i, rate)"
                            >
                              <div class="rate-tile">
                                <p class="rate-length">{{ pageLabels.variableRateTermHeader }}</p>
                                <p class="rate-price" [innerHTML]="rate.PricePerTherm | perTherm: true"></p>
                                <p class="rate-therm-text">{{ pageLabels.pricePerThermText }}</p>
                              </div>
                            </button>
                          }
                        </div>
                        <div class="rate-desc">
                          <p>{{ pageLabels.planIncludesText }}</p>
                          <ul>
                            @for (bullet of pageLabels.variableIncludesList; track $index) {
                              <li>{{ bullet.bullet }}</li>
                            }
                          </ul>
                          <p>{{ pageLabels.variableDisclaimer }}</p>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  }
                }
              </mat-accordion>
            </div>
            <div class="side-content">
              @if (isSSMProcess) {
                <app-ssm-side-panel [panelData]="ssmData" [step]="step"></app-ssm-side-panel>
              } @else {
                <app-rate-detail [panelData]="sidePanelData"></app-rate-detail>
              }
            </div>
          </div>
          <div class="page-link-container">
            <mat-divider class="divider"></mat-divider>
            <mat-checkbox class="terms-checkbox" color="primary" formControlName="terms"
              >{{ pageLabels.termsText }}
              <a [href]="pageLabels.termsLinkUrl" target="_blank" rel="noopener noreferrer"
                >{{ pageLabels.termsLinkText }}<span class="cdk-visually-hidden"> (opens in new tab)</span
                ><i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square"></i
              ></a>
            </mat-checkbox>
            @if (rateForm.get("terms")?.touched && rateForm.get("terms")?.hasError("required")) {
              <mat-error id="termConditionsError" class="gs-error terms-error">{{
                pageLabels.termsErrorText
              }}</mat-error>
            }
            <mat-divider class="divider"></mat-divider>
            @if (isSSMProcess) {
              <div class="ssm-button-container">
                <a [routerLink]="goBack()">{{ pageLabels.backButtonText }}</a>
                <button
                  (click)="confirmRenewal()"
                  role="link"
                  class="gs-form-button-primary submit-rate-btn"
                  mat-flat-button
                  color="primary"
                >
                  {{ pageLabels.submitButtonText }}
                </button>
              </div>
            } @else {
              <button
                (click)="confirmRenewal()"
                role="link"
                class="gs-form-button-primary submit-rate-btn"
                mat-flat-button
                color="primary"
              >
                {{ pageLabels.confirmRateBtnText }}
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  </main>

  <ng-template #calculatedTooltip let-data>
    <div>
      <h2 mat-dialog-title [innerHTML]="data.header"></h2>
      <mat-dialog-content>{{ data.bodyText }}</mat-dialog-content>
      <mat-dialog-actions class="calculated-btns">
        <button mat-flat-button mat-dialog-close color="primary" class="gs-form-button-primary">
          {{ data.ctaBtnText }}
        </button>
      </mat-dialog-actions>
    </div>
  </ng-template>
}
